export {
  type HasDirtyCheck,
  type DirtyCheckStrategy,
  dirtyCheckCanDeactivateGuard,
} from './lib/dirty-check';
